import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import research from "../../Assets/Projects/research.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import game from "../../Assets/Projects/game.png";
import website from "../../Assets/Projects/website.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Main <strong className="purple">Projects </strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={game}
              isBlog={false}
              title="Game"
              description="A twisted take on the classic “Three Little Pigs” story, built using Godot software. Developed with a partner, the game features engaging levels and a unique storyline that reimagines the traditional tale. Players navigate challenges and make choices that influence the outcome, combining strategy, problem-solving, and interactive storytelling."
              ghLink = "https://github.com/anpham09/Daydream-Atlanta"
              demoLink="https://seahong28.itch.io/three-little-pigs"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={research}
              isBlog={false}
              title="Research"
              description="Ongoing research with Professor Zhenlin An at UGA as part of project Aria. The project focuses on developing AURA(Accelerated Understanding and Reasoning Analyzer), a system designed to enhance vision-guided reasoning and enable real-time augmented visual cognition. Currently in progress, the research explores integrating AURA with Meta Aria Glasses for real-world applications."
              ghLink = "https://hl-demo.github.io/"
              demoLink="https://www.projectaria.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={website}
              isBlog={false}
              title="Website"
              description="Participated as an intern at Springwalk, Inc., contributing to projects focused on enhancing and optimizing the company website. Gained experience in web development, user experience improvements, and collaborative project workflows."

              demoLink="https://www.springwalk.com/"
            />
          </Col>




        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
